<div class="comments-section">
  <div class="d-flex justify-content-between align-items-center">
    <h5>Comments</h5>
    <button *ngIf="(isApprover || isAdmin) && hasAvailableTopicsToAdd" type="button" class="btn btn-primary"
      (click)="openCommentTopicModal()">
      New Topic
    </button>
  </div>

  <!-- Message displayed when no comment topics are available -->
  <div *ngIf="!commentTopics || commentTopics.length === 0" class="text-center p-4">
    <p>No comment topics available</p>
    <p *ngIf="!(isApprover || isAdmin)" class="text-muted mt-2">Please wait for an approver to add a comment topic.</p>
    <p *ngIf="(isApprover || isAdmin) && hasAvailableTopicsToAdd" class="text-muted mt-2">Click the "New Topic" button
      to start a discussion.</p>
    <p *ngIf="(isApprover || isAdmin) && !hasAvailableTopicsToAdd" class="text-muted mt-2">No available comment topics
      to add at this time.</p>
  </div>

  <hr />

  <!-- Comment Topic Selector -->
  <div class="row mb-3">
    <div class="col-md-4">
      <label for="commentTopic" class="form-label">Topic</label>
      <select id="commentTopic" class="form-control" [(ngModel)]="selectedCommentTopic" (change)="loadComments()">
        <option *ngFor="let topic of commentTopics" [value]="topic">
          {{ topic }}
        </option>
      </select>
    </div>
  </div>

  <!-- CCO topic guidance link -->
  <div class="alert alert-info" *ngIf="isCcoTopic">
    <a href="https://aka.ms/lionrock-rdqdirect" target="_blank">Request permission</a> to discuss with reviewers in
    RDQuota directly.
  </div>

  <!--Add New Comment Section (moved above comments) -->
  <div class="row mb-3 align-items-start" *ngIf="canAddComment">
    <div class="col-md-10 mb-2">
      <textarea class="form-control" [(ngModel)]="newComment" placeholder="{{ placeHolder }}" rows="3"></textarea>
    </div>
    <div class="col-md-10 mt-0">
      <button type="submit" class="btn btn-primary" [disabled]="!isValidComment()" (click)="saveNewComment()">
        Submit
      </button>
    </div>
  </div>

  <!-- Comments Display -->
  <div class="communication-modal" *ngIf="comments && comments.length > 0">
    <div *ngFor="let comment of comments">
      <b>{{ comment.By }}</b>
      <p class="text-muted small mb-1">{{ comment.At | date: 'medium' }}</p>
      <div [innerHTML]="comment.Comment?.replace('\n', '<br />')"></div>
      <hr />
    </div>
  </div>
  <!-- Empty state message -->
<div class="alert alert-light text-center" *ngIf="!comments || comments.length === 0">
  No comments available for this topic.
</div>

</div>
